<template>
    <span class="renderer user-simple-renderer py-1">
        <router-link :to="link">
            <div 
                class="identification-mask rounded" 
                :style="'background-image: url('+getPicture+')'"
            ></div>
            <span class="name">{{ object.name }}</span>
        </router-link>
    </span>
</template>

<script>

    import Utils from '@/services/utils.js'
    import {useDvFlagAccess} from "../../services/featureFlag";

    var userPlaceholderG = require("@/assets/img/user-no-img.png");

    export default {
        name: 'tablerowuserrenderer',
        props: ['object'],
        data: () => ({

        }),
        computed: {
            getPicture: function(){
                if(this.object.picture != null){
                    return this.object.picture;
                }
                return userPlaceholderG;
            },
            link(){
                if(useDvFlagAccess("beepiz-identifications-can:update")){
                    return '/parameters/identifications/'+this.object.id
                }
                else{
                    return ''
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
